import React from 'react'

const Icon = ({ type = '', className }) => {
	const icon = type?.toLowerCase()
	const defaultClassname = 'white-on-dark-bg'

	const render = (icon) => {
		switch (icon) {
			case 'play':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
					</svg>
				)
			case 'call':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M18.59 10.52c1.05.51 2.04 1.15 2.96 1.91l-1.07 1.07c-.58-.47-1.21-.89-1.88-1.27v-1.71m-13.2 0v1.7c-.65.37-1.28.79-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.38 2.94-1.9M12 7C7.46 7 3.34 8.78.29 11.67c-.18.18-.29.43-.29.71s.11.53.29.7l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.1.7-.28.79-.73 1.68-1.36 2.66-1.85.33-.16.56-.51.56-.9v-3.1C8.85 9.25 10.4 9 12 9s3.15.25 4.59.73v3.1c0 .4.23.74.56.9.98.49 1.88 1.11 2.67 1.85.18.17.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.11-.53-.29-.71C20.66 8.78 16.54 7 12 7z" />
					</svg>
				)
			case 'call-end':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M18.59 10.52c1.05.51 2.04 1.15 2.96 1.91l-1.07 1.07c-.58-.47-1.21-.89-1.88-1.27v-1.71m-13.2 0v1.7c-.65.37-1.28.79-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.38 2.94-1.9M12 7C7.46 7 3.34 8.78.29 11.67c-.18.18-.29.43-.29.71s.11.53.29.7l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.1.7-.28.79-.73 1.68-1.36 2.66-1.85.33-.16.56-.51.56-.9v-3.1C8.85 9.25 10.4 9 12 9s3.15.25 4.59.73v3.1c0 .4.23.74.56.9.98.49 1.88 1.11 2.67 1.85.18.17.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.11-.53-.29-.71C20.66 8.78 16.54 7 12 7z" />
					</svg>
				)

			case 'action':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<rect fill="none" height="24" width="24" />
						<path d="M22,5.18L10.59,16.6l-4.24-4.24l1.41-1.41l2.83,2.83l10-10L22,5.18z M19.79,10.22C19.92,10.79,20,11.39,20,12 c0,4.42-3.58,8-8,8s-8-3.58-8-8c0-4.42,3.58-8,8-8c1.58,0,3.04,0.46,4.28,1.25l1.44-1.44C16.1,2.67,14.13,2,12,2C6.48,2,2,6.48,2,12 c0,5.52,4.48,10,10,10s10-4.48,10-10c0-1.19-0.22-2.33-0.6-3.39L19.79,10.22z" />
					</svg>
				)
			case 'missing-image':
				return (
					<svg
						preserveAspectRatio="none"
						className={`missing-image ${className ? className : defaultClassname}`}
						viewBox="64 64 896 896"
						focusable="false"
						data-icon="file-image"
						width="1em"
						height="1em"
						fill="currentColor"
						aria-hidden="true">
						<path d="M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"></path>
					</svg>
				)
			case 'leave':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
					</svg>
				)
			case 'consultation':
				return (
					<svg className={defaultClassname} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M1.12221 15.8599C0.239484 14.0781 -0.137986 12.0872 0.0450877 10.0945L0.0452249 10.093C0.371211 6.57371 2.06658 3.71229 5.05813 1.76961L5.066 1.7645L5.07393 1.75946C5.78453 1.30743 6.57054 0.912625 7.39574 0.622798C13.1048 -1.38232 19.3681 1.61317 21.3759 7.32543L21.3763 7.32645C22.4107 10.2746 22.1467 13.5096 20.6716 16.2387L20.6694 16.2427C17.8446 21.441 11.4555 23.4631 6.1816 20.8816C5.14932 21.0228 4.12856 21.1641 3.10602 21.3056L3.06664 21.3111L0.337452 21.5839L0.666801 19.0818C0.727486 18.6207 0.788719 18.1719 0.849203 17.7285C0.879092 17.5093 0.908799 17.2916 0.938166 17.0743L0.941596 17.049L0.945674 17.0237C1.00743 16.641 1.06807 16.2477 1.12221 15.8599ZM6.68826 18.8922C11.0694 21.2892 16.5323 19.6672 18.9121 15.2877C19.2923 14.5844 19.5742 13.8401 19.7557 13.075C19.9157 12.4003 19.9977 11.7095 20 11.0164C20.0022 10.3373 19.928 9.65588 19.776 8.9853C19.6999 8.64983 19.6043 8.31706 19.4891 7.98863C17.8484 3.32081 12.7281 0.869753 8.05849 2.5098C7.39141 2.74409 6.74235 3.06849 6.14739 3.44697C3.67737 5.05096 2.30714 7.35784 2.0367 10.2775C1.87444 12.0437 2.25305 13.8099 3.11846 15.3598C3.15452 15.4319 3.19058 15.522 3.17255 15.6121C3.10259 16.1716 3.01566 16.7481 2.92822 17.2921C2.92553 17.3089 2.92283 17.3256 2.92014 17.3423C2.89009 17.5646 2.86004 17.7848 2.82999 18.0051C2.80464 18.191 2.77928 18.3768 2.75393 18.5639C2.74911 18.5994 2.74429 18.6351 2.73947 18.6707C2.70954 18.8921 2.67962 19.1154 2.6497 19.3428L2.82999 19.3248C3.45385 19.2384 4.07771 19.1521 4.70429 19.0657C5.25473 18.9899 5.80726 18.914 6.36374 18.8381C6.47191 18.8201 6.59812 18.8562 6.68826 18.8922Z"
							fill="#1F416B"
						/>
					</svg>
				)
			case 'conditional-render':
				return (
					<svg
						className={defaultClassname}
						viewBox="64 64 896 896"
						focusable="false"
						data-icon="sisternode"
						width="1em"
						height="1em"
						fill="currentColor"
						aria-hidden="true">
						<path d="M672 432c-120.3 0-219.9 88.5-237.3 204H320c-15.5 0-28-12.5-28-28V244h291c14.2 35.2 48.7 60 89 60 53 0 96-43 96-96s-43-96-96-96c-40.3 0-74.8 24.8-89 60H112v72h108v364c0 55.2 44.8 100 100 100h114.7c17.4 115.5 117 204 237.3 204 132.5 0 240-107.5 240-240S804.5 432 672 432zm128 266c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z"></path>
					</svg>
				)
			case 'collapsible-paragraph':
				return (
					<svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor" aria-hidden="true">
						<path d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 000-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0014.4 7z"></path>
					</svg>
				)
			case 'ecrf-editor':
				return (
					<svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor" aria-hidden="true">
						<path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0z"></path>
					</svg>
				)
			case 'diagnostic':
				return (
					<svg className={defaultClassname} width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M0 0H4.72853V2.60549H2.56642C2.68461 6.18036 3.28308 9.4052 4.13308 11.7544C4.57951 12.9882 5.08613 13.9547 5.6093 14.6027C6.13974 15.2597 6.62419 15.5159 7.02686 15.5159C7.42543 15.5159 7.90414 15.2651 8.42891 14.6219C8.9468 13.987 9.44935 13.0394 9.89393 11.8278C10.758 9.4731 11.3679 6.21844 11.4873 2.60578H9.3252V0.000297775H14.0541L14.053 1.55745L14.053 1.55906C14.0293 5.74306 13.4281 9.54078 12.4028 12.432C11.8902 13.8774 11.2657 15.1133 10.5411 16.0601C9.88429 16.9182 9.12726 17.5615 8.27668 17.8862V17.9492C8.27668 20.4138 10.205 22.3948 12.5423 22.3948C14.8427 22.3948 16.7468 20.476 16.8065 18.0655L16.8079 17.9473V11.0055C15.8429 10.509 15.2006 9.48274 15.2006 8.32788C15.2006 6.69101 16.4875 5.33652 18.1005 5.33652C19.7135 5.33652 21 6.69104 21 8.32788C21 9.49982 20.3388 10.5369 19.3526 11.0245V17.9489C19.3526 21.8239 16.3118 25 12.542 25C8.81895 25 5.80657 21.9016 5.73282 18.0922L5.73279 18.0905L5.73276 18.0887L5.73275 18.0872L5.73146 17.9539L5.73145 17.9524L5.73144 17.9505L5.73143 17.9489V17.8661C4.91447 17.5421 4.18472 16.9237 3.54827 16.1043C2.81599 15.1615 2.18516 13.9252 1.66745 12.4768C0.631857 9.57935 0.0243982 5.76397 0.000719173 1.55845L1.28599e-06 1.30419L0 0Z"
							fill="#1E406A"
						/>
					</svg>
				)
			case 'treatment':
				return (
					<svg className={defaultClassname} width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M16.6465 8.51536L14.0314 11.1395L13.5287 11.6445C13.1538 12.0213 12.5703 12.0613 12.152 11.7623C12.1016 11.7281 12.0559 11.6881 12.0114 11.6445C11.9669 11.5998 11.9294 11.5539 11.8943 11.5033L10.3231 9.92809L9.90477 9.5078L9.48649 9.08752L7.91763 7.51233C7.86724 7.47819 7.82155 7.43933 7.77703 7.39578C7.73367 7.35104 7.69384 7.30513 7.65986 7.25568C7.36343 6.83422 7.40209 6.24911 7.77703 5.87356L8.27733 5.37087L10.8034 2.83738C10.8316 2.80324 10.8632 2.77263 10.8937 2.74202C12.4824 1.148 15.0578 1.148 16.6465 2.74202C18.2353 4.33605 18.2353 6.92134 16.6465 8.51536ZM9.88185 1.72615C9.84553 1.76383 9.80921 1.8015 9.77406 1.83799L2.23908 9.39961L2.01998 9.61976L2.01646 9.62329C-0.0187206 11.7848 0.018774 15.1941 2.12777 17.3121C4.27543 19.4665 7.75762 19.4665 9.90412 17.3121L17.6582 9.52911C19.8047 7.37588 19.8047 3.88174 17.6582 1.72615C15.5105 -0.428253 12.0295 -0.427076 9.88185 1.72615Z"
							fill="black"
						/>
					</svg>
				)
			case 'forward':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<rect fill="none" height="24" width="24" />
						</g>
						<g>
							<g>
								<path d="M11,8v5l4.25,2.52l0.77-1.28l-3.52-2.09V8H11z M21,10V3l-2.64,2.64C16.74,4.01,14.49,3,12,3c-4.97,0-9,4.03-9,9 s4.03,9,9,9s9-4.03,9-9h-2c0,3.86-3.14,7-7,7s-7-3.14-7-7s3.14-7,7-7c1.93,0,3.68,0.79,4.95,2.05L14,10H21z" />
							</g>
						</g>
					</svg>
				)
			case 'remove':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z" />
					</svg>
				)
			case 'edit':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z" />
					</svg>
				)
			case 'add':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
					</svg>
				)
			case 'close':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
					</svg>
				)
			case 'save':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z" />
					</svg>
				)
			case 'download':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zm-5.55-8h-2.9v3H8l4 4 4-4h-2.55z" />
					</svg>
				)
			case 'ecrf':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<path d="M0,0h24v24H0V0z" fill="none" />
						</g>
						<g>
							<g>
								<path d="M15,3H5C3.9,3,3.01,3.9,3.01,5L3,19c0,1.1,0.89,2,1.99,2H19c1.1,0,2-0.9,2-2V9L15,3z M5,19V5h9v5h5v9H5z M9,8 c0,0.55-0.45,1-1,1S7,8.55,7,8s0.45-1,1-1S9,7.45,9,8z M9,12c0,0.55-0.45,1-1,1s-1-0.45-1-1s0.45-1,1-1S9,11.45,9,12z M9,16 c0,0.55-0.45,1-1,1s-1-0.45-1-1s0.45-1,1-1S9,15.45,9,16z" />
							</g>
						</g>
					</svg>
				)
			case 'stop':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<rect fill="none" height="24" width="24" />
						<path d="M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M12,20c-4.42,0-8-3.58-8-8s3.58-8,8-8 s8,3.58,8,8S16.42,20,12,20z M16,16H8V8h8V16z" />
					</svg>
				)
			case 'disable':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<rect fill="none" height="24" width="24" />
						<path d="M20,17.17l-3.37-3.38c0.64,0.22,1.23,0.48,1.77,0.76C19.37,15.06,19.98,16.07,20,17.17z M21.19,21.19l-1.41,1.41L17.17,20H4 v-2.78c0-1.12,0.61-2.15,1.61-2.66c1.29-0.66,2.87-1.22,4.67-1.45L1.39,4.22l1.41-1.41L21.19,21.19z M15.17,18l-3-3 c-0.06,0-0.11,0-0.17,0c-2.37,0-4.29,0.73-5.48,1.34C6.2,16.5,6,16.84,6,17.22V18H15.17z M12,6c1.1,0,2,0.9,2,2 c0,0.86-0.54,1.59-1.3,1.87l1.48,1.48C15.28,10.64,16,9.4,16,8c0-2.21-1.79-4-4-4c-1.4,0-2.64,0.72-3.35,1.82l1.48,1.48 C10.41,6.54,11.14,6,12,6z" />
					</svg>
				)
			case 'open':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M11 7h6v2h-6zm0 4h6v2h-6zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zM20.1 3H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM19 19H5V5h14v14z" />
					</svg>
				)
			case 'goto':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
					</svg>
				)
			case 'youtube':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#808080">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
					</svg>
				)
			case 'add-article':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#808080">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M13 11h-2v3H8v2h3v3h2v-3h3v-2h-3zm1-9H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" />
					</svg>
				)
			case 'add-attachment':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#808080">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" />
					</svg>
				)
			case 'add-link':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#808080">
						<g>
							<rect fill="none" height="24" width="24" />
						</g>
						<g>
							<path d="M8,11h8v2H8V11z M20.1,12H22c0-2.76-2.24-5-5-5h-4v1.9h4C18.71,8.9,20.1,10.29,20.1,12z M3.9,12c0-1.71,1.39-3.1,3.1-3.1h4 V7H7c-2.76,0-5,2.24-5,5s2.24,5,5,5h4v-1.9H7C5.29,15.1,3.9,13.71,3.9,12z M19,12h-2v3h-3v2h3v3h2v-3h3v-2h-3V12z" />
						</g>
					</svg>
				)
			case 'add-image':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#808080">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z" />
					</svg>
				)
			case 'loupe':
				return (
					<svg className={defaultClassname} width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M22.2431 20.9181L16.6501 15.3251C18.1742 13.461 18.9235 11.0824 18.7431 8.68131C18.5627 6.28023 17.4663 4.04034 15.6808 2.42495C13.8952 0.809556 11.557 -0.0577415 9.14992 0.00244732C6.74282 0.0626361 4.45093 1.04571 2.74832 2.74832C1.04571 4.45093 0.0626361 6.74282 0.00244732 9.14992C-0.0577415 11.557 0.809556 13.8952 2.42495 15.6808C4.04034 17.4663 6.28023 18.5627 8.68131 18.7431C11.0824 18.9235 13.461 18.1742 15.3251 16.6501L20.9181 22.2431C21.0046 22.332 21.108 22.4028 21.2222 22.4514C21.3364 22.5001 21.4591 22.5256 21.5832 22.5264C21.7072 22.5272 21.8303 22.5034 21.9451 22.4563C22.0599 22.4092 22.1642 22.3397 22.252 22.252C22.3397 22.1642 22.4092 22.0599 22.4563 21.9451C22.5034 21.8303 22.5272 21.7072 22.5264 21.5832C22.5256 21.4591 22.5001 21.3364 22.4514 21.2222C22.4028 21.108 22.332 21.0046 22.2431 20.9181ZM9.40006 16.8961C7.9167 16.8961 6.46665 16.4562 5.23328 15.6321C3.99992 14.808 3.03862 13.6366 2.47096 12.2662C1.90331 10.8957 1.75478 9.38774 2.04417 7.93288C2.33356 6.47803 3.04787 5.14165 4.09676 4.09276C5.14565 3.04387 6.48203 2.32956 7.93688 2.04017C9.39174 1.75078 10.8997 1.89931 12.2702 2.46696C13.6406 3.03462 14.812 3.99591 15.6361 5.22928C16.4602 6.46265 16.9001 7.9127 16.9001 9.39606C16.9001 11.3852 16.1099 13.2928 14.7034 14.6994C13.2968 16.1059 11.3892 16.8961 9.40006 16.8961Z"
							fill="#1E406A"
						/>
					</svg>
				)
			case 'task':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<rect fill="none" height="24" width="24" />
						<path d="M22,5.18L10.59,16.6l-4.24-4.24l1.41-1.41l2.83,2.83l10-10L22,5.18z M19.79,10.22C19.92,10.79,20,11.39,20,12 c0,4.42-3.58,8-8,8s-8-3.58-8-8c0-4.42,3.58-8,8-8c1.58,0,3.04,0.46,4.28,1.25l1.44-1.44C16.1,2.67,14.13,2,12,2C6.48,2,2,6.48,2,12 c0,5.52,4.48,10,10,10s10-4.48,10-10c0-1.19-0.22-2.33-0.6-3.39L19.79,10.22z" />
					</svg>
				)
			case 'expand':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0,0h24v24H0V0z" fill="none" />
						<path d="M3,18h13v-2H3V18z M3,13h10v-2H3V13z M3,6v2h13V6H3z M21,15.59L17.42,12L21,8.41L19.59,7l-5,5l5,5L21,15.59z" />
					</svg>
				)
			case 'compress':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
					</svg>
				)
			case 'dashboard':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z" />
					</svg>
				)
			case 'administrative':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<path d="M0,0h24v24H0V0z" fill="none" />
						</g>
						<g>
							<g>
								<path d="M4,18v-0.65c0-0.34,0.16-0.66,0.41-0.81C6.1,15.53,8.03,15,10,15c0.03,0,0.05,0,0.08,0.01c0.1-0.7,0.3-1.37,0.59-1.98 C10.45,13.01,10.23,13,10,13c-2.42,0-4.68,0.67-6.61,1.82C2.51,15.34,2,16.32,2,17.35V20h9.26c-0.42-0.6-0.75-1.28-0.97-2H4z" />
								<path d="M10,12c2.21,0,4-1.79,4-4s-1.79-4-4-4C7.79,4,6,5.79,6,8S7.79,12,10,12z M10,6c1.1,0,2,0.9,2,2s-0.9,2-2,2 c-1.1,0-2-0.9-2-2S8.9,6,10,6z" />
								<path d="M20.75,16c0-0.22-0.03-0.42-0.06-0.63l1.14-1.01l-1-1.73l-1.45,0.49c-0.32-0.27-0.68-0.48-1.08-0.63L18,11h-2l-0.3,1.49 c-0.4,0.15-0.76,0.36-1.08,0.63l-1.45-0.49l-1,1.73l1.14,1.01c-0.03,0.21-0.06,0.41-0.06,0.63s0.03,0.42,0.06,0.63l-1.14,1.01 l1,1.73l1.45-0.49c0.32,0.27,0.68,0.48,1.08,0.63L16,21h2l0.3-1.49c0.4-0.15,0.76-0.36,1.08-0.63l1.45,0.49l1-1.73l-1.14-1.01 C20.72,16.42,20.75,16.22,20.75,16z M17,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S18.1,18,17,18z" />
							</g>
						</g>
					</svg>
				)
			case 'edit-user':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<path d="M0,0h24v24H0V0z" fill="none" />
						</g>
						<g>
							<g>
								<path d="M4,18v-0.65c0-0.34,0.16-0.66,0.41-0.81C6.1,15.53,8.03,15,10,15c0.03,0,0.05,0,0.08,0.01c0.1-0.7,0.3-1.37,0.59-1.98 C10.45,13.01,10.23,13,10,13c-2.42,0-4.68,0.67-6.61,1.82C2.51,15.34,2,16.32,2,17.35V20h9.26c-0.42-0.6-0.75-1.28-0.97-2H4z" />
								<path d="M10,12c2.21,0,4-1.79,4-4s-1.79-4-4-4C7.79,4,6,5.79,6,8S7.79,12,10,12z M10,6c1.1,0,2,0.9,2,2s-0.9,2-2,2 c-1.1,0-2-0.9-2-2S8.9,6,10,6z" />
								<path d="M20.75,16c0-0.22-0.03-0.42-0.06-0.63l1.14-1.01l-1-1.73l-1.45,0.49c-0.32-0.27-0.68-0.48-1.08-0.63L18,11h-2l-0.3,1.49 c-0.4,0.15-0.76,0.36-1.08,0.63l-1.45-0.49l-1,1.73l1.14,1.01c-0.03,0.21-0.06,0.41-0.06,0.63s0.03,0.42,0.06,0.63l-1.14,1.01 l1,1.73l1.45-0.49c0.32,0.27,0.68,0.48,1.08,0.63L16,21h2l0.3-1.49c0.4-0.15,0.76-0.36,1.08-0.63l1.45,0.49l1-1.73l-1.14-1.01 C20.72,16.42,20.75,16.22,20.75,16z M17,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S18.1,18,17,18z" />
							</g>
						</g>
					</svg>
				)
			case 'register':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M11 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM5 18c.2-.63 2.57-1.68 4.96-1.94l2.04-2c-.39-.04-.68-.06-1-.06-2.67 0-8 1.34-8 4v2h9l-2-2H5zm15.6-5.5l-5.13 5.17-2.07-2.08L12 17l3.47 3.5L22 13.91z" />
					</svg>
				)
			case 'care-management':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<rect fill="none" height="24" width="24" />
						<path d="M21.29,13.9L18,12l3.29-1.9c0.48-0.28,0.64-0.89,0.37-1.37l-2-3.46c-0.28-0.48-0.89-0.64-1.37-0.37L15,6.8V3 c0-0.55-0.45-1-1-1h-4C9.45,2,9,2.45,9,3v3.8L5.71,4.9C5.23,4.63,4.62,4.79,4.34,5.27l-2,3.46C2.06,9.21,2.23,9.82,2.71,10.1L6,12 l-3.29,1.9c-0.48,0.28-0.64,0.89-0.37,1.37l2,3.46c0.28,0.48,0.89,0.64,1.37,0.37L9,17.2V21c0,0.55,0.45,1,1,1h4c0.55,0,1-0.45,1-1 v-3.8l3.29,1.9c0.48,0.28,1.09,0.11,1.37-0.37l2-3.46C21.94,14.79,21.77,14.18,21.29,13.9z M18.43,16.87l-4.68-2.7 C13.42,13.97,13,14.21,13,14.6V20h-2v-5.4c0-0.38-0.42-0.63-0.75-0.43l-4.68,2.7l-1-1.73l4.68-2.7c0.33-0.19,0.33-0.67,0-0.87 l-4.68-2.7l1-1.73l4.68,2.7C10.58,10.03,11,9.79,11,9.4V4h2v5.4c0,0.38,0.42,0.63,0.75,0.43l4.68-2.7l1,1.73l-4.68,2.7 c-0.33,0.19-0.33,0.67,0,0.87l4.68,2.7L18.43,16.87z" />
					</svg>
				)
			case 'patients':
				return (
					<svg className={defaultClassname} width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M19 0H5C3.67441 0.00158786 2.40356 0.528882 1.46622 1.46622C0.528882 2.40356 0.00158786 3.67441 0 5L0 17C0.00158786 18.3256 0.528882 19.5964 1.46622 20.5338C2.40356 21.4711 3.67441 21.9984 5 22H19C20.3256 21.9984 21.5964 21.4711 22.5338 20.5338C23.4711 19.5964 23.9984 18.3256 24 17V5C23.9984 3.67441 23.4711 2.40356 22.5338 1.46622C21.5964 0.528882 20.3256 0.00158786 19 0ZM5 2H19C19.7956 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V6H2V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2ZM19 20H5C4.20435 20 3.44129 19.6839 2.87868 19.1213C2.31607 18.5587 2 17.7956 2 17V8H22V17C22 17.7956 21.6839 18.5587 21.1213 19.1213C20.5587 19.6839 19.7956 20 19 20ZM19 12C19 12.2652 18.8946 12.5196 18.7071 12.7071C18.5196 12.8946 18.2652 13 18 13H6C5.73478 13 5.48043 12.8946 5.29289 12.7071C5.10536 12.5196 5 12.2652 5 12C5 11.7348 5.10536 11.4804 5.29289 11.2929C5.48043 11.1054 5.73478 11 6 11H18C18.2652 11 18.5196 11.1054 18.7071 11.2929C18.8946 11.4804 19 11.7348 19 12ZM15 16C15 16.2652 14.8946 16.5196 14.7071 16.7071C14.5196 16.8946 14.2652 17 14 17H6C5.73478 17 5.48043 16.8946 5.29289 16.7071C5.10536 16.5196 5 16.2652 5 16C5 15.7348 5.10536 15.4804 5.29289 15.2929C5.48043 15.1054 5.73478 15 6 15H14C14.2652 15 14.5196 15.1054 14.7071 15.2929C14.8946 15.4804 15 15.7348 15 16ZM3 4C3 3.80222 3.05865 3.60888 3.16853 3.44443C3.27841 3.27998 3.43459 3.15181 3.61732 3.07612C3.80004 3.00043 4.00111 2.98063 4.19509 3.01921C4.38907 3.0578 4.56725 3.15304 4.70711 3.29289C4.84696 3.43275 4.9422 3.61093 4.98079 3.80491C5.01937 3.99889 4.99957 4.19996 4.92388 4.38268C4.84819 4.56541 4.72002 4.72159 4.55557 4.83147C4.39112 4.94135 4.19778 5 4 5C3.73478 5 3.48043 4.89464 3.29289 4.70711C3.10536 4.51957 3 4.26522 3 4ZM6 4C6 3.80222 6.05865 3.60888 6.16853 3.44443C6.27841 3.27998 6.43459 3.15181 6.61732 3.07612C6.80004 3.00043 7.00111 2.98063 7.19509 3.01921C7.38907 3.0578 7.56725 3.15304 7.70711 3.29289C7.84696 3.43275 7.9422 3.61093 7.98079 3.80491C8.01937 3.99889 7.99957 4.19996 7.92388 4.38268C7.84819 4.56541 7.72002 4.72159 7.55557 4.83147C7.39112 4.94135 7.19778 5 7 5C6.73478 5 6.48043 4.89464 6.29289 4.70711C6.10536 4.51957 6 4.26522 6 4ZM9 4C9 3.80222 9.05865 3.60888 9.16853 3.44443C9.27841 3.27998 9.43459 3.15181 9.61732 3.07612C9.80004 3.00043 10.0011 2.98063 10.1951 3.01921C10.3891 3.0578 10.5673 3.15304 10.7071 3.29289C10.847 3.43275 10.9422 3.61093 10.9808 3.80491C11.0194 3.99889 10.9996 4.19996 10.9239 4.38268C10.8482 4.56541 10.72 4.72159 10.5556 4.83147C10.3911 4.94135 10.1978 5 10 5C9.73478 5 9.48043 4.89464 9.29289 4.70711C9.10536 4.51957 9 4.26522 9 4Z"
							fill="#40B6F9"
						/>
					</svg>
				)
			case 'ott':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<path d="M0,0h24v24H0V0z" fill="none" />
						</g>
						<g>
							<g>
								<path d="M10.5,15H8v-3h2.5V9.5h3V12H16v3h-2.5v2.5h-3V15z M19,8v11c0,1.1-0.9,2-2,2H7c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h10 C18.1,6,19,6.9,19,8z M17,8H7v11h10V8z M18,3H6v2h12V3z" />
							</g>
						</g>
					</svg>
				)
			case 'laboratory':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<rect fill="none" height="24" width="24" />
						</g>
						<g>
							<path d="M13,11.33L18,18H6l5-6.67V6h2 M15.96,4H8.04C7.62,4,7.39,4.48,7.65,4.81L9,6.5v4.17L3.2,18.4C2.71,19.06,3.18,20,4,20h16 c0.82,0,1.29-0.94,0.8-1.6L15,10.67V6.5l1.35-1.69C16.61,4.48,16.38,4,15.96,4L15.96,4z" />
						</g>
					</svg>
				)
			case 'rpalarms':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#FFFFFF">
						<path d="M0 0h24v24H0z" fill="none" />
						<path d="M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z" />
					</svg>
				)
			case 'inquiries':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#FFFFFF">
						<rect fill="none" height="24" width="24" />
						<path d="M23,17c0,3.31-2.69,6-6,6v-1.5c2.48,0,4.5-2.02,4.5-4.5H23z M1,7c0-3.31,2.69-6,6-6v1.5C4.52,2.5,2.5,4.52,2.5,7H1z M8.01,4.32l-4.6,4.6c-3.22,3.22-3.22,8.45,0,11.67s8.45,3.22,11.67,0l7.07-7.07c0.49-0.49,0.49-1.28,0-1.77 c-0.49-0.49-1.28-0.49-1.77,0l-4.42,4.42l-0.71-0.71l6.54-6.54c0.49-0.49,0.49-1.28,0-1.77s-1.28-0.49-1.77,0l-5.83,5.83l-0.71-0.71 l6.89-6.89c0.49-0.49,0.49-1.28,0-1.77s-1.28-0.49-1.77,0l-6.89,6.89L11.02,9.8l5.48-5.48c0.49-0.49,0.49-1.28,0-1.77 s-1.28-0.49-1.77,0l-7.62,7.62c1.22,1.57,1.11,3.84-0.33,5.28l-0.71-0.71c1.17-1.17,1.17-3.07,0-4.24l-0.35-0.35l4.07-4.07 c0.49-0.49,0.49-1.28,0-1.77C9.29,3.83,8.5,3.83,8.01,4.32z" />
					</svg>
				)
			case 'adherence':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#FFFFFF">
						<g>
							<rect fill="none" height="24" width="24" />
						</g>
						<g>
							<g>
								<path
									d="M20,3H4C2.9,3,2,3.9,2,5v14c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V5 C22,3.9,21.1,3,20,3z M10,17H5v-2h5V17z M10,13H5v-2h5V13z M10,9H5V7h5V9z M14.82,15L12,12.16l1.41-1.41l1.41,1.42L17.99,9 l1.42,1.42L14.82,15z"
									fillRule="evenodd"
								/>
							</g>
						</g>
					</svg>
				)
			case 'termin-koordination':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#FFFFFF">
						<path d="M0 0h24v24H0z" fill="none" />
						<path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z" />
					</svg>
				)
			case 'recruitement':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<rect fill="none" height="24" width="24" />
						<path d="M16,4c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S16,5.1,16,4z M20.78,7.58C19.93,7.21,18.99,7,18,7c-0.67,0-1.31,0.1-1.92,0.28 C16.66,7.83,17,8.6,17,9.43V10h5V9.43C22,8.62,21.52,7.9,20.78,7.58z M6,6c1.1,0,2-0.9,2-2S7.1,2,6,2S4,2.9,4,4S4.9,6,6,6z M7.92,7.28C7.31,7.1,6.67,7,6,7C5.01,7,4.07,7.21,3.22,7.58C2.48,7.9,2,8.62,2,9.43V10h5V9.43C7,8.6,7.34,7.83,7.92,7.28z M10,4 c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S10,5.1,10,4z M16,10H8V9.43C8,8.62,8.48,7.9,9.22,7.58C10.07,7.21,11.01,7,12,7 c0.99,0,1.93,0.21,2.78,0.58C15.52,7.9,16,8.62,16,9.43V10z M15,16c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S15,17.1,15,16z M21,22h-8 v-0.57c0-0.81,0.48-1.53,1.22-1.85C15.07,19.21,16.01,19,17,19c0.99,0,1.93,0.21,2.78,0.58C20.52,19.9,21,20.62,21,21.43V22z M5,16 c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S5,17.1,5,16z M11,22H3v-0.57c0-0.81,0.48-1.53,1.22-1.85C5.07,19.21,6.01,19,7,19 c0.99,0,1.93,0.21,2.78,0.58C10.52,19.9,11,20.62,11,21.43V22z M12.75,13v-2h-1.5v2H9l3,3l3-3H12.75z" />
					</svg>
				)
			case 'steps':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<rect fill="none" height="24" width="24" />
						</g>
						<g>
							<g>
								<path
									d="M20,3H4C2.9,3,2,3.9,2,5v14c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V5 C22,3.9,21.1,3,20,3z M20,19H4V5h16V19z"
									fillRule="evenodd"
								/>
								<polygon fillRule="evenodd" points="19.41,10.42 17.99,9 14.82,12.17 13.41,10.75 12,12.16 14.82,15" />
								<rect fillRule="evenodd" height="2" width="5" x="5" y="7" />
								<rect fillRule="evenodd" height="2" width="5" x="5" y="11" />
								<rect fillRule="evenodd" height="2" width="5" x="5" y="15" />
							</g>
						</g>
					</svg>
				)
			case 'events':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5z" />
					</svg>
				)
			case 'periods':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<rect fill="none" height="24" width="24" />
						</g>
						<g>
							<path d="M21,12V6c0-1.1-0.9-2-2-2h-1V2h-2v2H8V2H6v2H5C3.9,4,3,4.9,3,6v14c0,1.1,0.9,2,2,2h7v-2H5V10h14v2H21z M19,8H5V6h14V8z M15.64,20c0.43,1.45,1.77,2.5,3.36,2.5c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5c-0.95,0-1.82,0.38-2.45,1l1.45,0V18h-4v-4h1.5 l0,1.43C16.4,14.55,17.64,14,19,14c2.76,0,5,2.24,5,5s-2.24,5-5,5c-2.42,0-4.44-1.72-4.9-4L15.64,20z" />
						</g>
					</svg>
				)
			case 'careplans':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<rect fill="none" height="24" width="24" />
						</g>
						<g>
							<g>
								<rect height="2" width="12" x="3" y="3" />
								<path d="M2,21h14V6H2V21z M5,12h2.5V9.5h3V12H13v3h-2.5v2.5h-3V15H5V12z" />
								<path d="M20,6c-1.68,0-3,1.76-3,4c0,1.77,0.83,3.22,2,3.76V21h2v-7.24c1.17-0.54,2-1.99,2-3.76C23,7.76,21.68,6,20,6z" />
							</g>
						</g>
					</svg>
				)
			case 'content':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z" />
					</svg>
				)
			case 'cms':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<rect fill="none" height="24" width="24" />
							<g>
								<path d="M19,5v14H5V5H19 M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3L19,3z" />
							</g>
							<path d="M14,17H7v-2h7V17z M17,13H7v-2h10V13z M17,9H7V7h10V9z" />
						</g>
					</svg>
				)
			case 'report-a-bug':
				return (
					<svg
						viewBox="64 64 896 896"
						focusable="false"
						data-icon="warning"
						width="1em"
						height="1em"
						fill={className === 'errorClass' ? '#ff0000' : 'currentColor'}
						aria-hidden="true">
						<path d="M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"></path>
					</svg>
				)
			case 'analytics':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z" />
					</svg>
				)
			case 'support':
				return (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<rect fill="none" height="24" width="24" />
						</g>
						<g>
							<g>
								<path d="M21,12.22C21,6.73,16.74,3,12,3c-4.69,0-9,3.65-9,9.28C2.4,12.62,2,13.26,2,14v2c0,1.1,0.9,2,2,2h1v-6.1 c0-3.87,3.13-7,7-7s7,3.13,7,7V19h-8v2h8c1.1,0,2-0.9,2-2v-1.22c0.59-0.31,1-0.92,1-1.64v-2.3C22,13.14,21.59,12.53,21,12.22z" />
								<circle cx="9" cy="13" r="1" />
								<circle cx="15" cy="13" r="1" />
								<path d="M18,11.03C17.52,8.18,15.04,6,12.05,6c-3.03,0-6.29,2.51-6.03,6.45c2.47-1.01,4.33-3.21,4.86-5.89 C12.19,9.19,14.88,11,18,11.03z" />
							</g>
						</g>
					</svg>
				)
			case 'eproscores':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#FFFFFF">
						<path d="M0 0h24v24H0z" fill="none" />
						<path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z" />
					</svg>
				)
			case 'rpa-analysis':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#FFFFFF">
						<path d="M0 0h24v24H0z" fill="none" />
						<path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z" />
					</svg>
				)
			case 'time-to-deterioration':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#FFFFFF">
						<path d="M0 0h24v24H0z" fill="none" />
						<path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z" />
					</svg>
				)
			case 'engagement':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z" />
					</svg>
				)
			case 'assessment':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<path d="M0,0h24v24H0V0z" fill="none" />
						</g>
						<g>
							<path d="M4,6H2v14c0,1.1,0.9,2,2,2h14v-2H4V6z M20,2H8C6.9,2,6,2.9,6,4v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V4 C22,2.9,21.1,2,20,2z M20,16H8V4h12V16z M13.51,10.16c0.41-0.73,1.18-1.16,1.63-1.8c0.48-0.68,0.21-1.94-1.14-1.94 c-0.88,0-1.32,0.67-1.5,1.23l-1.37-0.57C11.51,5.96,12.52,5,13.99,5c1.23,0,2.08,0.56,2.51,1.26c0.37,0.6,0.58,1.73,0.01,2.57 c-0.63,0.93-1.23,1.21-1.56,1.81c-0.13,0.24-0.18,0.4-0.18,1.18h-1.52C13.26,11.41,13.19,10.74,13.51,10.16z M12.95,13.95 c0-0.59,0.47-1.04,1.05-1.04c0.59,0,1.04,0.45,1.04,1.04c0,0.58-0.44,1.05-1.04,1.05C13.42,15,12.95,14.53,12.95,13.95z" />
						</g>
					</svg>
				)
			case 'appointment':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM7 11h5v5H7z" />
					</svg>
				)
			case 'refresh':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
					</svg>
				)
			case 'reset':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<rect fill="none" height="24" width="24" />
						<path d="M13,3c-4.97,0-9,4.03-9,9H1l4,4l4-4H6c0-3.86,3.14-7,7-7s7,3.14,7,7s-3.14,7-7,7c-1.9,0-3.62-0.76-4.88-1.99L6.7,18.42 C8.32,20.01,10.55,21,13,21c4.97,0,9-4.03,9-9S17.97,3,13,3z M15,11v-1c0-1.1-0.9-2-2-2s-2,0.9-2,2v1c-0.55,0-1,0.45-1,1v3 c0,0.55,0.45,1,1,1h4c0.55,0,1-0.45,1-1v-3C16,11.45,15.55,11,15,11z M14,11h-2v-1c0-0.55,0.45-1,1-1s1,0.45,1,1V11z" />
					</svg>
				)
			case 'logo':
				return (
					<svg className={defaultClassname} width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M36.1197 18.0498C35.7728 18.0498 35.4401 18.1876 35.1948 18.4329C34.9495 18.6782 34.8117 19.0109 34.8117 19.3578C34.81 22.9011 33.6403 26.345 31.4839 29.1566C29.3275 31.9682 26.3045 33.9906 22.8827 34.9108C22.5758 34.9925 22.3091 35.183 22.1324 35.4469C21.9557 35.7107 21.881 36.0298 21.9222 36.3447C21.9635 36.6596 22.1179 36.9487 22.3566 37.1581C22.5954 37.3676 22.9021 37.4829 23.2197 37.4828C23.3342 37.4825 23.4481 37.4674 23.5587 37.4378C27.5367 36.3681 31.0513 34.017 33.5584 30.7484C36.0655 27.4799 37.4255 23.4761 37.4277 19.3568C37.4275 19.0101 37.2895 18.6776 37.0443 18.4326C36.799 18.1875 36.4665 18.0498 36.1197 18.0498Z"
							fill="#42A6A2"
						/>
						<path
							d="M2.616 19.3537C2.61615 15.6512 3.89239 12.062 6.22971 9.19057C8.56702 6.31915 11.8226 4.34105 15.4479 3.58951C19.0733 2.83797 22.8469 3.35891 26.1331 5.06458C29.4192 6.77025 32.0171 9.5564 33.489 12.9537C33.6272 13.2719 33.8861 13.5223 34.2089 13.6496C34.5316 13.777 34.8917 13.7709 35.21 13.6327C35.5283 13.4945 35.7786 13.2355 35.9059 12.9128C36.0333 12.59 36.0272 12.2299 35.889 11.9117C34.1777 7.96247 31.1575 4.72375 27.3373 2.74114C23.5171 0.758527 19.1303 0.153183 14.9159 1.02709C10.7015 1.90099 6.91705 4.20074 4.20015 7.5389C1.48325 10.8771 -0.000102546 15.0496 5.31705e-09 19.3537C5.3171e-09 19.7006 0.137805 20.0333 0.383102 20.2786C0.6284 20.5239 0.961095 20.6617 1.308 20.6617C1.6549 20.6617 1.9876 20.5239 2.23289 20.2786C2.47819 20.0333 2.616 19.7006 2.616 19.3537Z"
							fill="#42A6A2"
						/>
						<path
							d="M27.8589 26.8894C27.7391 26.7662 27.5963 26.6678 27.4385 26.5998C27.2807 26.5318 27.1111 26.4956 26.9393 26.4932C26.7675 26.4908 26.5969 26.5222 26.4372 26.5858C26.2776 26.6493 26.132 26.7436 26.0089 26.8634C24.5186 28.3162 22.6267 29.2885 20.5779 29.6544C20.5629 29.6544 20.5489 29.6544 20.5339 29.6544C20.4612 29.6665 20.3876 29.6725 20.3139 29.6724C20.1432 29.6724 19.9741 29.6388 19.8164 29.5735C19.6587 29.5082 19.5154 29.4124 19.3946 29.2917C19.2739 29.171 19.1782 29.0276 19.1128 28.8699C19.0475 28.7122 19.0139 28.5432 19.0139 28.3724C19.0132 28.1971 19.0483 28.0235 19.1171 27.8622C19.1859 27.7009 19.2869 27.5553 19.4139 27.4344C19.4239 27.4244 19.4299 27.4134 19.4399 27.4034C19.4499 27.3934 19.4599 27.3874 19.4689 27.3784L20.5939 26.1604C23.5629 23.3334 25.9039 21.0954 25.9039 18.0604C25.9274 17.431 25.8251 16.8032 25.603 16.2138C25.3809 15.6244 25.0435 15.0852 24.6105 14.6278C24.1775 14.1704 23.6576 13.804 23.0812 13.55C22.5049 13.2959 21.8836 13.1594 21.2539 13.1484C20.3505 13.1531 19.4678 13.4188 18.7119 13.9134C17.9564 13.4187 17.0739 13.153 16.1709 13.1484C15.5411 13.1594 14.9199 13.2959 14.3435 13.55C13.7672 13.804 13.2473 14.1704 12.8143 14.6278C12.3812 15.0852 12.0438 15.6244 11.8217 16.2138C11.5997 16.8032 11.4974 17.431 11.5209 18.0604C11.6209 19.8999 12.3844 21.6408 13.6699 22.9604C13.8953 23.2246 14.2164 23.3884 14.5626 23.4158C14.7341 23.4293 14.9065 23.409 15.07 23.3559C15.2336 23.3028 15.3851 23.2181 15.5159 23.1064C15.6467 22.9948 15.7542 22.8585 15.8323 22.7053C15.9104 22.5522 15.9576 22.3851 15.9712 22.2137C15.9848 22.0423 15.9644 21.8699 15.9113 21.7063C15.8583 21.5427 15.7735 21.3912 15.6619 21.2604C14.779 20.4164 14.2364 19.2778 14.1369 18.0604C14.1171 17.7755 14.1542 17.4894 14.2461 17.2189C14.3379 16.9483 14.4826 16.6988 14.6718 16.4848C14.861 16.2707 15.0909 16.0965 15.3481 15.9721C15.6053 15.8478 15.8846 15.7758 16.1699 15.7604C16.4686 15.7686 16.7625 15.8378 17.0335 15.9637C17.3045 16.0896 17.5469 16.2695 17.7459 16.4924C17.8684 16.6264 18.0175 16.7333 18.1837 16.8065C18.3498 16.8797 18.5293 16.9175 18.7109 16.9175C18.8924 16.9175 19.072 16.8797 19.2381 16.8065C19.4042 16.7333 19.5533 16.6264 19.6759 16.4924C19.8752 16.2697 20.1179 16.0899 20.389 15.9641C20.6601 15.8382 20.9541 15.7689 21.2529 15.7604C21.5381 15.7758 21.8175 15.8478 22.0747 15.9721C22.3319 16.0965 22.5618 16.2707 22.7509 16.4848C22.9401 16.6988 23.0849 16.9483 23.1767 17.2189C23.2686 17.4894 23.3057 17.7755 23.2859 18.0604C23.2859 19.9854 21.3859 21.7934 18.7589 24.2954C18.7389 24.3144 18.7189 24.3344 18.6999 24.3544L17.5459 25.6034L17.5369 25.6154C17.1737 25.9771 16.8858 26.4071 16.6898 26.8806C16.4937 27.3542 16.3935 27.8619 16.3949 28.3744C16.3959 29.4127 16.8089 30.4081 17.543 31.1423C18.2772 31.8765 19.2726 32.2894 20.3109 32.2904C20.4229 32.2904 20.5349 32.2904 20.6459 32.2764H20.6629C20.7356 32.2765 20.8082 32.2705 20.8799 32.2584C23.5018 31.8224 25.9271 30.5932 27.8289 28.7364C28.0773 28.4952 28.22 28.1654 28.2257 27.8191C28.2313 27.4729 28.0994 27.1386 27.8589 26.8894Z"
							fill="#D73E69"
						/>
						<path
							d="M29.1453 24.9798C29.4666 25.1092 29.8261 25.1057 30.1449 24.9702C30.4636 24.8346 30.7155 24.578 30.8453 24.2569C31.9828 21.4441 32.1074 18.3234 31.1977 15.4289C30.288 12.5344 28.4006 10.0461 25.8584 8.38982C23.3163 6.73357 20.2775 6.01237 17.2622 6.34968C14.2469 6.68698 11.4426 8.06181 9.32926 10.2389C9.2095 10.362 9.11517 10.5076 9.05166 10.6672C8.98815 10.8269 8.9567 10.9975 8.95911 11.1692C8.96153 11.341 8.99776 11.5107 9.06573 11.6684C9.1337 11.8262 9.23208 11.9691 9.35526 12.0889C9.47844 12.2086 9.624 12.303 9.78364 12.3665C9.94327 12.43 10.1138 12.4614 10.2856 12.459C10.4574 12.4566 10.6271 12.4204 10.7848 12.3524C10.9426 12.2844 11.0855 12.186 11.2053 12.0629C12.897 10.3245 15.1399 9.22753 17.5507 8.95931C19.9615 8.69109 22.3907 9.26828 24.4232 10.5923C26.4557 11.9162 27.9654 13.9049 28.6944 16.2184C29.4234 18.5319 29.3265 21.0268 28.4203 23.2768C28.3559 23.4363 28.3237 23.6068 28.3253 23.7787C28.3269 23.9506 28.3624 24.1205 28.4298 24.2786C28.4971 24.4368 28.5949 24.5801 28.7177 24.7005C28.8405 24.8208 28.9858 24.9157 29.1453 24.9798Z"
							fill="#42A6A2"
						/>
						<path
							d="M11.3323 26.7748C9.82736 25.2772 8.81324 23.3574 8.42444 21.2702C8.03564 19.183 8.29053 17.0268 9.15529 15.0878C9.29705 14.7711 9.3072 14.4111 9.18352 14.087C9.05984 13.7628 8.81246 13.501 8.49579 13.3593C8.17912 13.2175 7.81911 13.2074 7.49495 13.3311C7.1708 13.4547 6.90905 13.7021 6.76729 14.0188C5.67206 16.4666 5.35605 19.1921 5.86211 21.8256C6.36817 24.4591 7.67181 26.8732 9.59629 28.7408C9.61429 28.7578 9.63429 28.7688 9.65229 28.7848C9.90783 29.0604 10.0506 29.4219 10.0523 29.7978C10.0521 30.0971 9.96316 30.3896 9.79679 30.6383C9.63041 30.8871 9.39404 31.081 9.11753 31.1955C8.84102 31.31 8.53677 31.34 8.24323 31.2817C7.94969 31.2233 7.68003 31.0793 7.4683 30.8678C7.4583 30.8578 7.44729 30.8518 7.43729 30.8428C5.93813 29.3742 4.74154 27.6259 3.91529 25.6968C3.76663 25.3971 3.50883 25.1658 3.19486 25.0504C2.88089 24.935 2.53462 24.9442 2.22727 25.0763C1.91992 25.2083 1.67484 25.4531 1.54241 25.7602C1.40998 26.0674 1.40028 26.4137 1.51529 26.7278C2.47627 28.9741 3.86934 31.0097 5.6153 32.7188C5.6313 32.7348 5.6503 32.7458 5.6673 32.7608C6.44969 33.5267 7.5043 33.9505 8.59914 33.9389C9.69398 33.9273 10.7394 33.4812 11.5053 32.6988C12.2712 31.9164 12.695 30.8618 12.6834 29.767C12.6718 28.6721 12.2257 27.6267 11.4433 26.8608C11.4078 26.8302 11.3708 26.8015 11.3323 26.7748Z"
							fill="#42A6A2"
						/>
					</svg>
				)
			case 'cross':
				return (
					<svg className={defaultClassname} width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M6.67031 5.39794L4.73136 3.49794L6.67031 1.59794C6.70649 1.56074 6.72668 1.51133 6.72668 1.45994C6.72668 1.40855 6.70649 1.35913 6.67031 1.32194L5.75186 0.421937C5.7139 0.386479 5.66347 0.366699 5.61103 0.366699C5.55859 0.366699 5.50816 0.386479 5.4702 0.421937L3.53125 2.32194L1.5923 0.421937C1.55434 0.386479 1.50391 0.366699 1.45147 0.366699C1.39902 0.366699 1.34859 0.386479 1.31064 0.421937L0.392186 1.32194C0.356001 1.35913 0.335815 1.40855 0.335815 1.45994C0.335815 1.51133 0.356001 1.56074 0.392186 1.59794L2.33114 3.49794L0.392186 5.39794C0.356001 5.43513 0.335815 5.48455 0.335815 5.53594C0.335815 5.58733 0.356001 5.63674 0.392186 5.67394L1.31064 6.57394C1.34859 6.6094 1.39902 6.62918 1.45147 6.62918C1.50391 6.62918 1.55434 6.6094 1.5923 6.57394L3.53125 4.67394L5.4702 6.57394C5.50816 6.6094 5.55859 6.62918 5.61103 6.62918C5.66347 6.62918 5.7139 6.6094 5.75186 6.57394L6.67031 5.67394C6.70649 5.63674 6.72668 5.58733 6.72668 5.53594C6.72668 5.48455 6.70649 5.43513 6.67031 5.39794Z"
							fill="white"
						/>
					</svg>
				)
			case 'notification':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" />
					</svg>
				)
			case 'chat':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M15 4v7H5.17l-.59.59-.58.58V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z" />
					</svg>
				)

			case 'check':
				return (
					<svg className={defaultClassname} width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M3.5476 6.50511L0.764692 3.77811C0.684614 3.69939 0.639648 3.59277 0.639648 3.48161C0.639648 3.37046 0.684614 3.26384 0.764692 3.18511L1.36985 2.59411C1.45019 2.51564 1.559 2.47158 1.67243 2.47158C1.78586 2.47158 1.89467 2.51564 1.97501 2.59411L3.84967 4.42911L7.86534 0.494113C7.94568 0.415644 8.05448 0.371582 8.16792 0.371582C8.28135 0.371582 8.39016 0.415644 8.4705 0.494113L9.07565 1.08711C9.15573 1.16584 9.2007 1.27246 9.2007 1.38361C9.2007 1.49477 9.15573 1.60139 9.07565 1.68011L4.15276 6.50511C4.07242 6.58358 3.96361 6.62764 3.85018 6.62764C3.73674 6.62764 3.62794 6.58358 3.5476 6.50511Z"
							fill="white"
						/>
					</svg>
				)
			case 'question-mark':
				return (
					<svg className={defaultClassname} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M12.0014 0C5.37615 0 0.00134277 5.36802 0.00134277 11.9937C0.00134277 18.6257 5.37615 24 12.0013 24C18.6301 24 24.0004 18.6256 24.0004 11.9937C24.0005 5.36802 18.6301 0 12.0014 0ZM12.8565 18.6708C12.5778 18.9188 12.2548 19.0435 11.8889 19.0435C11.5103 19.0435 11.1801 18.9211 10.8982 18.6758C10.6159 18.4309 10.4745 18.0881 10.4745 17.6476C10.4745 17.2568 10.6113 16.928 10.8842 16.6614C11.1571 16.3949 11.4918 16.2616 11.8889 16.2616C12.2796 16.2616 12.6085 16.3949 12.8755 16.6614C13.142 16.928 13.2757 17.2568 13.2757 17.6476C13.2752 18.0817 13.1356 18.4228 12.8565 18.6708ZM16.3317 10.0553C16.1176 10.4523 15.8633 10.7947 15.5683 11.0834C15.2742 11.3721 14.7452 11.8573 13.9818 12.5394C13.7712 12.7318 13.6019 12.9008 13.4749 13.0462C13.348 13.1922 13.2531 13.3254 13.1912 13.4465C13.1289 13.5675 13.081 13.6886 13.0471 13.8096C13.0132 13.9302 12.9622 14.143 12.8931 14.447C12.7756 15.0921 12.4066 15.4146 11.7863 15.4146C11.4637 15.4146 11.1927 15.3094 10.9718 15.0984C10.7518 14.8874 10.642 14.5744 10.642 14.1588C10.642 13.638 10.7229 13.1866 10.8842 12.805C11.0445 12.4232 11.2591 12.0885 11.5257 11.7998C11.7926 11.5112 12.1522 11.1687 12.6053 10.7717C13.0024 10.4243 13.2892 10.1623 13.4659 9.98563C13.6429 9.80857 13.7916 9.61162 13.9122 9.39476C14.0337 9.17747 14.0933 8.94211 14.0933 8.68781C14.0933 8.19136 13.9095 7.77305 13.54 7.43199C13.1709 7.09094 12.6948 6.92016 12.1116 6.92016C11.429 6.92016 10.9267 7.09227 10.6041 7.4365C10.2816 7.78072 10.0092 8.28756 9.78557 8.95751C9.57417 9.65863 9.17392 10.0091 8.58528 10.0091C8.23788 10.0091 7.94473 9.88671 7.70576 9.64185C7.46724 9.39699 7.34798 9.13184 7.34798 8.84636C7.34798 8.25727 7.53726 7.66007 7.91539 7.0552C8.29396 6.45033 8.84598 5.94933 9.57189 5.5527C10.2974 5.15562 11.1444 4.95683 12.1116 4.95683C13.011 4.95683 13.8047 5.12305 14.4932 5.45511C15.1816 5.78666 15.7137 6.23798 16.0891 6.80895C16.4641 7.37948 16.652 7.99974 16.652 8.66969C16.6529 9.19603 16.5458 9.65819 16.3317 10.0553Z"
							fill="#1E406A"
						/>
					</svg>
				)
			case 'arrow-down':
				return (
					<svg className={defaultClassname} width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							opacity="0.3"
							d="M6.32106 5.36701L10.5451 1.13901C10.695 0.990013 10.8977 0.906379 11.1091 0.906379C11.3204 0.906379 11.5232 0.990013 11.6731 1.13901C11.8218 1.28967 11.9051 1.49283 11.9051 1.70451C11.9051 1.9162 11.8218 2.11936 11.6731 2.27001L6.88606 7.05801C6.74045 7.20182 6.54526 7.28435 6.34064 7.28863C6.13603 7.29291 5.93756 7.21861 5.78606 7.08101L0.966063 2.27101C0.884642 2.19865 0.818858 2.11042 0.772741 2.01174C0.726625 1.91305 0.701148 1.80599 0.697872 1.69711C0.694596 1.58823 0.71359 1.47982 0.75369 1.37854C0.79379 1.27726 0.854151 1.18524 0.931074 1.10811C1.008 1.03099 1.09986 0.970381 1.20103 0.930012C1.30221 0.889643 1.41056 0.870361 1.51944 0.873348C1.62833 0.876334 1.73546 0.901527 1.83427 0.947381C1.93308 0.993236 2.02148 1.05879 2.09406 1.14001L6.32106 5.36701Z"
							fill="#1E406A"
						/>
					</svg>
				)
			case 'logout':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						enableBackground="new 0 0 24 24"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<g>
							<path d="M0,0h24v24H0V0z" fill="none" />
						</g>
						<g>
							<path d="M17,8l-1.41,1.41L17.17,11H9v2h8.17l-1.58,1.58L17,16l4-4L17,8z M5,5h7V3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h7v-2H5V5z" />
						</g>
					</svg>
				)
			case 'help':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />
					</svg>
				)
			case 'back-arrows':
				return (
					<svg className={defaultClassname} width="25" height="15" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M4.06996 12.8061L13.007 3.87607C13.3231 3.559 13.5003 3.12934 13.4997 2.68159C13.499 2.23385 13.3205 1.80471 13.0035 1.48857C12.6864 1.17243 12.2567 0.995195 11.809 0.995851C11.3612 0.996508 10.9321 1.175 10.616 1.49207L0.490964 11.6061C0.185048 11.9132 0.00925545 12.3264 0.000129712 12.7597C-0.00899602 13.1931 0.149247 13.6134 0.441964 13.9331L10.609 24.1261C10.9251 24.4431 11.3542 24.6216 11.802 24.6223C12.2497 24.6229 12.6794 24.4457 12.9965 24.1296C13.3135 23.8134 13.492 23.3843 13.4927 22.9365C13.4933 22.4888 13.3161 22.0591 13 21.7421L4.06996 12.8061Z"
							fill="#40B6F9"
						/>
						<path
							d="M20.2739 12.8061L29.2109 3.87607C29.5271 3.559 29.7043 3.12934 29.7037 2.68159C29.703 2.23385 29.5245 1.80471 29.2074 1.48857C28.8904 1.17243 28.4607 0.995195 28.013 0.995851C27.5652 0.996508 27.1361 1.175 26.8199 1.49207L16.6949 11.6061C16.389 11.9132 16.2132 12.3264 16.2041 12.7597C16.195 13.1931 16.3532 13.6134 16.6459 13.9331L26.8129 24.1261C27.1291 24.4431 27.5582 24.6216 28.006 24.6223C28.4537 24.6229 28.8834 24.4457 29.2004 24.1296C29.5175 23.8134 29.696 23.3843 29.6967 22.9365C29.6973 22.4888 29.5201 22.0591 29.2039 21.7421L20.2739 12.8061Z"
							fill="#40B6F9"
						/>
					</svg>
				)
			case 'chemotherapie':
				return (
					<svg className={defaultClassname} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect width="21" height="21" rx="10.5" fill="#7899F8" />
						<path
							d="M12.3448 10.2847H11.0295V8.95801H9.93267V10.2847H8.61743V11.4003H9.93267V12.7269H11.0295V11.4003H12.3448V10.2847Z"
							fill="white"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M10.4811 14.871C12.6786 14.871 14.46 13.0673 14.46 10.8423C14.46 8.61734 12.6786 6.81365 10.4811 6.81365C8.28361 6.81365 6.50218 8.61734 6.50218 10.8423C6.50218 13.0673 8.28361 14.871 10.4811 14.871ZM10.4811 15.816C13.1941 15.816 15.3934 13.5892 15.3934 10.8423C15.3934 8.09543 13.1941 5.86865 10.4811 5.86865C7.76814 5.86865 5.56885 8.09543 5.56885 10.8423C5.56885 13.5892 7.76814 15.816 10.4811 15.816Z"
							fill="white"
						/>
					</svg>
				)
			case 'on-site':
				return (
					<svg className={defaultClassname} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M17.5879 7.11091V13.8909C17.5866 14.8596 17.2012 15.7882 16.5162 16.4732C15.8312 17.1582 14.9026 17.5436 13.9339 17.5449H13.2029C13.009 17.5449 12.8231 17.4679 12.686 17.3308C12.5489 17.1937 12.4719 17.0078 12.4719 16.8139C12.4719 16.62 12.5489 16.4341 12.686 16.297C12.8231 16.1599 13.009 16.0829 13.2029 16.0829H13.9339C14.2219 16.0829 14.507 16.0262 14.7731 15.916C15.0392 15.8058 15.2809 15.6442 15.4846 15.4406C15.6882 15.237 15.8497 14.9952 15.9599 14.7291C16.0702 14.4631 16.1269 14.1779 16.1269 13.8899V7.11091C16.1269 6.75196 16.0389 6.39849 15.8705 6.08151C15.702 5.76453 15.4584 5.49374 15.1609 5.29291L10.0469 1.84091C9.68536 1.59439 9.25795 1.46253 8.82038 1.46253C8.38281 1.46253 7.95539 1.59439 7.59388 1.84091L2.47488 5.29291C2.17737 5.49374 1.93372 5.76453 1.76529 6.08151C1.59686 6.39849 1.50882 6.75196 1.50888 7.11091V13.8909C1.50888 14.4725 1.73993 15.0303 2.15119 15.4416C2.56246 15.8529 3.12026 16.0839 3.70188 16.0839H4.43288C4.62675 16.0839 4.81268 16.1609 4.94977 16.298C5.08686 16.4351 5.16388 16.621 5.16388 16.8149C5.16388 17.0088 5.08686 17.1947 4.94977 17.3318C4.81268 17.4689 4.62675 17.5459 4.43288 17.5459H3.70088C2.73184 17.5446 1.80289 17.1589 1.11787 16.4735C0.432837 15.7881 0.0476723 14.8589 0.0468787 13.8899V7.11091C0.0460295 6.51275 0.192241 5.92355 0.472642 5.39518C0.753044 4.86681 1.15904 4.41548 1.65488 4.08091L6.77088 0.628907C7.37407 0.219415 8.08632 0.000488281 8.81538 0.000488281C9.54443 0.000488281 10.2567 0.219415 10.8599 0.628907L15.9759 4.08191C16.472 4.41624 16.8785 4.86729 17.1595 5.39543C17.4406 5.92356 17.5877 6.51264 17.5879 7.11091ZM13.9339 10.9719C13.9355 11.644 13.8038 12.3098 13.5463 12.9307C13.2888 13.5516 12.9107 14.1152 12.4339 14.5889L9.86588 17.1049C9.5845 17.3779 9.2079 17.5305 8.81588 17.5305C8.42386 17.5305 8.04725 17.3779 7.76588 17.1049L5.20588 14.5949C4.60982 14.0007 4.16957 13.2686 3.92417 12.4635C3.67876 11.6584 3.63579 10.8052 3.79904 9.97947C3.9623 9.15379 4.32674 8.38113 4.86007 7.73001C5.3934 7.07888 6.07914 6.5694 6.85649 6.24672C7.63385 5.92403 8.47881 5.79813 9.31647 5.88015C10.1541 5.96218 10.9586 6.24961 11.6586 6.71695C12.3586 7.1843 12.9325 7.81713 13.3294 8.55935C13.7263 9.30157 13.9339 10.1302 13.9339 10.9719ZM12.4719 10.9719C12.4716 10.3711 12.3233 9.7797 12.0399 9.24995C11.7566 8.7202 11.347 8.26849 10.8474 7.93481C10.3478 7.60114 9.77365 7.39578 9.17577 7.33694C8.57789 7.2781 7.97473 7.36758 7.41968 7.59746C6.86464 7.82735 6.37483 8.19054 5.99364 8.65488C5.61245 9.11923 5.35163 9.67039 5.23427 10.2596C5.11692 10.8488 5.14665 11.4578 5.32083 12.0328C5.49501 12.6078 5.80827 13.1309 6.23288 13.5559L8.79088 16.0559L11.4079 13.5489C11.7466 13.2109 12.015 12.8091 12.1976 12.3668C12.3802 11.9245 12.4734 11.4504 12.4719 10.9719ZM11.0099 10.9669C11.0099 11.4007 10.8812 11.8247 10.6402 12.1854C10.3992 12.546 10.0566 12.8271 9.65587 12.9931C9.2551 13.159 8.81411 13.2024 8.38868 13.1177C7.96325 13.033 7.5725 12.824 7.26584 12.5172C6.95918 12.2104 6.7504 11.8196 6.66589 11.3941C6.58139 10.9687 6.62496 10.5277 6.7911 10.127C6.95723 9.72629 7.23847 9.38386 7.59924 9.14301C7.96001 8.90216 8.3841 8.77371 8.81788 8.77391C9.39933 8.77417 9.95687 9.00534 10.3679 9.41658C10.779 9.82781 11.0099 10.3855 11.0099 10.9669Z"
							fill="#4CBBF9"
						/>
					</svg>
				)
			case 'video-call':
				return (
					<svg className={defaultClassname} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M8.72387 1.14994C8.72413 0.972417 8.79484 0.802257 8.92046 0.676824C9.04608 0.55139 9.21634 0.480939 9.39387 0.480939C11.1708 0.480939 12.875 1.18683 14.1315 2.44332C15.388 3.69982 16.0939 5.40399 16.0939 7.18094C16.0872 7.35402 16.0137 7.51779 15.8889 7.63788C15.7641 7.75798 15.5976 7.82506 15.4244 7.82506C15.2512 7.82506 15.0847 7.75798 14.9598 7.63788C14.835 7.51779 14.7616 7.35402 14.7549 7.18094C14.7549 5.75902 14.1901 4.39533 13.1847 3.38979C12.1794 2.38424 10.8158 1.8192 9.39387 1.81894C9.21617 1.81894 9.04575 1.74835 8.9201 1.6227C8.79445 1.49705 8.72387 1.32663 8.72387 1.14894V1.14994ZM9.39387 4.49794C10.1041 4.49794 10.7853 4.78008 11.2875 5.28231C11.7897 5.78453 12.0719 6.46569 12.0719 7.17594C12.0684 7.26604 12.0831 7.35591 12.1152 7.44017C12.1473 7.52444 12.196 7.60136 12.2585 7.66634C12.3211 7.73132 12.396 7.783 12.479 7.81831C12.562 7.85362 12.6512 7.87182 12.7414 7.87182C12.8315 7.87182 12.9208 7.85362 13.0037 7.81831C13.0867 7.783 13.1617 7.73132 13.2242 7.66634C13.2867 7.60136 13.3355 7.52444 13.3675 7.44017C13.3996 7.35591 13.4143 7.26604 13.4109 7.17594C13.4101 6.11072 12.9866 5.08933 12.2335 4.33601C11.4804 3.58269 10.4591 3.159 9.39387 3.15794C9.30377 3.15446 9.2139 3.16919 9.12963 3.20127C9.04536 3.23335 8.96844 3.2821 8.90346 3.34461C8.83849 3.40713 8.7868 3.48211 8.75149 3.56507C8.71619 3.64804 8.69799 3.73727 8.69799 3.82744C8.69799 3.9176 8.71619 4.00684 8.75149 4.0898C8.7868 4.17277 8.83849 4.24775 8.90346 4.31026C8.96844 4.37278 9.04536 4.42153 9.12963 4.45361C9.2139 4.48568 9.30377 4.50042 9.39387 4.49694V4.49794ZM15.4819 11.6879C15.8699 12.0769 16.0879 12.604 16.0879 13.1534C16.0879 13.7029 15.8699 14.2299 15.4819 14.6189L14.8729 15.3189C9.38887 20.5699 -3.95413 7.22994 1.21487 1.72994L1.98487 1.05994C2.37456 0.681956 2.89754 0.472818 3.44041 0.477873C3.98328 0.482927 4.50228 0.701766 4.88487 1.08694C4.90587 1.10794 6.14587 2.71894 6.14587 2.71894C6.51477 3.10502 6.72063 3.61845 6.72063 4.15244C6.72063 4.68643 6.51477 5.19986 6.14587 5.58594L5.37087 6.56094C5.79951 7.60318 6.42979 8.55048 7.22554 9.34846C8.02129 10.1464 8.96683 10.7794 10.0079 11.2109L10.9889 10.4309C11.3749 10.0623 11.8881 9.85665 12.4219 9.85665C12.9556 9.85665 13.4688 10.0623 13.8549 10.4309C13.8549 10.4309 15.4609 11.6669 15.4819 11.6869V11.6879ZM14.5609 12.6609C14.5609 12.6609 12.9609 11.4279 12.9379 11.4079C12.8 11.2711 12.6136 11.1943 12.4194 11.1943C12.2251 11.1943 12.0387 11.2711 11.9009 11.4079C11.8829 11.4269 10.5329 12.5029 10.5329 12.5029C10.4417 12.575 10.3334 12.622 10.2186 12.6396C10.1038 12.6571 9.98635 12.6445 9.87787 12.6029C8.52811 12.1002 7.3022 11.3132 6.28321 10.2952C5.26422 9.27729 4.47597 8.05218 3.97187 6.70294C3.9275 6.59245 3.91338 6.47213 3.93095 6.35437C3.94853 6.23661 3.99717 6.12566 4.07187 6.03294C4.07187 6.03294 5.14387 4.68594 5.16187 4.66894C5.29872 4.53107 5.37551 4.34469 5.37551 4.15044C5.37551 3.95618 5.29872 3.76981 5.16187 3.63194C5.14087 3.61194 3.90787 2.00794 3.90787 2.00794C3.76793 1.88228 3.5852 1.81496 3.39719 1.81979C3.20918 1.82463 3.03016 1.90125 2.89687 2.03394L2.12687 2.70394C-1.65013 7.24594 9.91287 18.1679 13.8929 14.4039L14.5029 13.7039C14.6456 13.5715 14.7313 13.3888 14.7419 13.1945C14.7525 13.0001 14.6873 12.8091 14.5599 12.6619L14.5609 12.6609Z"
							fill="#4CBBF9"
						/>
					</svg>
				)
			case 'print':
				return (
					<svg
						className={defaultClassname}
						xmlns="http://www.w3.org/2000/svg"
						height="24px"
						viewBox="0 0 24 24"
						width="24px"
						fill="#000000">
						<path d="M0 0h24v24H0V0z" fill="none" />
						<path d="M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 12v2H8v-4h8v2zm2-2v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z" />
						<circle cx="18" cy="11.5" r="1" />
					</svg>
				)
			case 'calendar':
				return (
					<svg className={defaultClassname} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M0.280029 9.91808C0.280029 10.6076 0.553957 11.269 1.04155 11.7566C1.52915 12.2442 2.19047 12.5181 2.88003 12.5181H10.165C10.8546 12.5181 11.5159 12.2442 12.0035 11.7566C12.4911 11.269 12.765 10.6076 12.765 9.91808V5.23608H0.280029V9.91808ZM9.12403 7.57708C9.2783 7.57708 9.4291 7.62283 9.55737 7.70854C9.68564 7.79425 9.78562 7.91606 9.84466 8.05859C9.90369 8.20112 9.91914 8.35795 9.88904 8.50925C9.85895 8.66056 9.78466 8.79954 9.67557 8.90863C9.56649 9.01771 9.4275 9.092 9.2762 9.1221C9.12489 9.15219 8.96806 9.13675 8.82554 9.07771C8.68301 9.01867 8.56119 8.9187 8.47548 8.79043C8.38978 8.66216 8.34403 8.51135 8.34403 8.35708C8.34403 8.15022 8.42621 7.95182 8.57249 7.80554C8.71876 7.65926 8.91716 7.57708 9.12403 7.57708ZM6.52403 7.57708C6.6783 7.57708 6.8291 7.62283 6.95737 7.70854C7.08564 7.79425 7.18562 7.91606 7.24466 8.05859C7.30369 8.20112 7.31914 8.35795 7.28904 8.50925C7.25895 8.66056 7.18466 8.79954 7.07557 8.90863C6.96649 9.01771 6.82751 9.092 6.6762 9.1221C6.52489 9.15219 6.36806 9.13675 6.22554 9.07771C6.08301 9.01867 5.96119 8.9187 5.87548 8.79043C5.78978 8.66216 5.74403 8.51135 5.74403 8.35708C5.74403 8.15039 5.82607 7.95214 5.97213 7.80589C6.11819 7.65964 6.31633 7.57735 6.52303 7.57708H6.52403ZM3.92403 7.57708C4.0783 7.57708 4.2291 7.62283 4.35737 7.70854C4.48564 7.79425 4.58562 7.91606 4.64466 8.05859C4.70369 8.20112 4.71914 8.35795 4.68904 8.50925C4.65895 8.66056 4.58466 8.79954 4.47557 8.90863C4.36649 9.01771 4.2275 9.092 4.0762 9.1221C3.92489 9.15219 3.76806 9.13675 3.62554 9.07771C3.48301 9.01867 3.36119 8.9187 3.27548 8.79043C3.18978 8.66216 3.14403 8.51135 3.14403 8.35708C3.14403 8.15022 3.22621 7.95182 3.37249 7.80554C3.51876 7.65926 3.71716 7.57708 3.92403 7.57708Z"
							fill="white"
						/>
						<path
							d="M10.165 1.07397H9.64503V0.552971C9.64503 0.484618 9.63157 0.416934 9.60541 0.353784C9.57925 0.290634 9.54091 0.233255 9.49258 0.184922C9.44425 0.136589 9.38687 0.098249 9.32372 0.0720914C9.26057 0.0459338 9.19288 0.0324707 9.12453 0.0324707C9.05618 0.0324707 8.98849 0.0459338 8.92534 0.0720914C8.86219 0.098249 8.80481 0.136589 8.75648 0.184922C8.70815 0.233255 8.66981 0.290634 8.64365 0.353784C8.61749 0.416934 8.60403 0.484618 8.60403 0.552971V1.07297H4.44203V0.552971C4.44203 0.414926 4.38719 0.282534 4.28958 0.184922C4.19197 0.087309 4.05958 0.0324707 3.92153 0.0324707C3.78348 0.0324707 3.65109 0.087309 3.55348 0.184922C3.45587 0.282534 3.40103 0.414926 3.40103 0.552971V1.07297H2.88003C2.53842 1.07297 2.20017 1.14029 1.88459 1.27108C1.56901 1.40186 1.2823 1.59356 1.04084 1.8352C0.799387 2.07684 0.607914 2.3637 0.477369 2.67938C0.346824 2.99506 0.279767 3.33337 0.28003 3.67497V4.19497H12.766V3.67497C12.7662 3.33337 12.699 2.99508 12.5683 2.67946C12.4376 2.36383 12.2461 2.07704 12.0045 1.83549C11.763 1.59394 11.4762 1.40236 11.1605 1.27169C10.8449 1.14103 10.5066 1.07384 10.165 1.07397Z"
							fill="white"
						/>
					</svg>
				)
			case 'caret-down':
				return (
					<svg className={defaultClassname} xmlns="http://www.w3.org/2000/svg" width="7" height="4" viewBox="0 0 7 4" fill="none">
						<path
							d="M1.38199 0.249023H6.54199C6.63311 0.249685 6.72201 0.277281 6.79749 0.328341C6.87297 0.3794 6.93167 0.451642 6.96619 0.535977C7.00072 0.620313 7.00953 0.712975 6.99152 0.802307C6.97351 0.891639 6.92949 0.97365 6.86499 1.03802L4.28999 3.61402C4.24706 3.65717 4.19602 3.69141 4.13982 3.71477C4.08362 3.73813 4.02335 3.75016 3.96249 3.75016C3.90162 3.75016 3.84136 3.73813 3.78515 3.71477C3.72895 3.69141 3.67792 3.65717 3.63499 3.61402L1.05899 1.03802C0.994483 0.97365 0.950458 0.891639 0.93245 0.802307C0.914442 0.712975 0.923255 0.620313 0.95778 0.535977C0.992306 0.451642 1.051 0.3794 1.12648 0.328341C1.20196 0.277281 1.29086 0.249685 1.38199 0.249023Z"
							fill="#40B6F9"
						/>
					</svg>
				)
			case 'dropdown-icon':
				return (
					<svg className={defaultClassname} width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M1.82418 0.208008H13.0042C13.202 0.208837 13.395 0.268292 13.559 0.378855C13.723 0.489418 13.8505 0.646123 13.9254 0.829156C14.0004 1.01219 14.0193 1.21333 13.98 1.40714C13.9406 1.60095 13.8446 1.77874 13.7042 1.91801L8.12418 7.49801C8.03121 7.59174 7.92061 7.66613 7.79875 7.7169C7.67689 7.76767 7.54619 7.79381 7.41418 7.79381C7.28217 7.79381 7.15146 7.76767 7.0296 7.7169C6.90774 7.66613 6.79714 7.59174 6.70418 7.49801L1.12418 1.91801C0.983755 1.77874 0.887784 1.60095 0.848399 1.40714C0.809014 1.21333 0.827983 1.01219 0.902909 0.829156C0.977834 0.646123 1.10535 0.489418 1.26933 0.378855C1.43332 0.268292 1.6264 0.208837 1.82418 0.208008Z"
							fill="#1E406A"
						/>
					</svg>
				)
			case 'settings':
				return (
					<svg className={defaultClassname} width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M11.374 8C10.5829 8 9.80954 8.2346 9.15175 8.67412C8.49395 9.11365 7.98126 9.73836 7.67851 10.4693C7.37576 11.2002 7.29654 12.0044 7.45088 12.7804C7.60522 13.5563 7.98619 14.269 8.5456 14.8284C9.10501 15.3878 9.81774 15.7688 10.5937 15.9231C11.3696 16.0775 12.1739 15.9983 12.9048 15.6955C13.6357 15.3928 14.2604 14.8801 14.6999 14.2223C15.1394 13.5645 15.374 12.7911 15.374 12C15.374 10.9391 14.9526 9.92172 14.2025 9.17157C13.4523 8.42143 12.4349 8 11.374 8ZM11.374 14C10.9785 14 10.5918 13.8827 10.2629 13.6629C9.93399 13.4432 9.67764 13.1308 9.52627 12.7654C9.37489 12.3999 9.33528 11.9978 9.41245 11.6098C9.48963 11.2219 9.68011 10.8655 9.95981 10.5858C10.2395 10.3061 10.5959 10.1156 10.9838 10.0384C11.3718 9.96126 11.7739 10.0009 12.1394 10.1522C12.5048 10.3036 12.8172 10.56 13.037 10.8889C13.2567 11.2178 13.374 11.6044 13.374 12C13.374 12.5304 13.1633 13.0391 12.7882 13.4142C12.4132 13.7893 11.9045 14 11.374 14Z"
							fill="#1E406A"
						/>
						<path
							d="M20.6679 13.9L20.2239 13.644C20.4238 12.5564 20.4238 11.4416 20.2239 10.354L20.6679 10.098C21.0094 9.90102 21.3087 9.63871 21.5487 9.32606C21.7888 9.01341 21.9649 8.65654 22.0671 8.27582C22.1692 7.8951 22.1954 7.49799 22.1441 7.10716C22.0927 6.71633 21.9649 6.33944 21.7679 5.998C21.571 5.65656 21.3087 5.35727 20.996 5.1172C20.6833 4.87714 20.3265 4.70101 19.9458 4.59886C19.565 4.49672 19.1679 4.47056 18.7771 4.52189C18.3863 4.57321 18.0094 4.70102 17.6679 4.898L17.2229 5.155C16.3825 4.43692 15.4166 3.88025 14.3739 3.513V3C14.3739 2.20435 14.0579 1.44129 13.4953 0.87868C12.9327 0.31607 12.1696 0 11.3739 0C10.5783 0 9.81523 0.31607 9.25262 0.87868C8.69001 1.44129 8.37394 2.20435 8.37394 3V3.513C7.33133 3.88157 6.36579 4.4396 5.52594 5.159L5.07394 4.9C4.38438 4.50218 3.56502 4.39457 2.79612 4.60086C2.02722 4.80715 1.37176 5.31044 0.973939 6C0.576115 6.68956 0.468512 7.50892 0.674802 8.27782C0.881092 9.04672 1.38438 9.70218 2.07394 10.1L2.51794 10.356C2.31805 11.4436 2.31805 12.5584 2.51794 13.646L2.07394 13.9C1.38438 14.2978 0.881092 14.9533 0.674802 15.7222C0.468512 16.4911 0.576115 17.3104 0.973939 18C1.37176 18.6896 2.02722 19.1928 2.79612 19.3991C3.56502 19.6054 4.38438 19.4978 5.07394 19.1L5.51894 18.843C6.36104 19.5624 7.329 20.1198 8.37394 20.487V21C8.37394 21.7956 8.69001 22.5587 9.25262 23.1213C9.81523 23.6839 10.5783 24 11.3739 24C12.1696 24 12.9327 23.6839 13.4953 23.1213C14.0579 22.5587 14.3739 21.7956 14.3739 21V20.487C15.4166 20.1184 16.3821 19.5604 17.2219 18.841L17.6689 19.099C18.3585 19.4968 19.1779 19.6044 19.9468 19.3981C20.7157 19.1918 21.3711 18.6886 21.7689 17.999C22.1668 17.3094 22.2744 16.4901 22.0681 15.7212C21.8618 14.9523 21.3585 14.2968 20.6689 13.899L20.6679 13.9ZM18.1199 10.124C18.4586 11.3511 18.4586 12.6469 18.1199 13.874C18.0608 14.0876 18.0743 14.3147 18.1583 14.5198C18.2423 14.7249 18.392 14.8963 18.5839 15.007L19.6679 15.633C19.7817 15.6987 19.8815 15.7861 19.9615 15.8903C20.0415 15.9945 20.1002 16.1135 20.1342 16.2403C20.1682 16.3672 20.1769 16.4996 20.1598 16.6298C20.1427 16.7601 20.1001 16.8857 20.0344 16.9995C19.9688 17.1133 19.8813 17.213 19.7771 17.293C19.6729 17.373 19.554 17.4317 19.4271 17.4658C19.3002 17.4998 19.1679 17.5085 19.0376 17.4914C18.9073 17.4743 18.7817 17.4317 18.6679 17.366L17.5819 16.738C17.3898 16.6267 17.1662 16.5826 16.9462 16.6124C16.7262 16.6423 16.5224 16.7445 16.3669 16.903C15.4769 17.8117 14.3555 18.46 13.1239 18.778C12.909 18.8333 12.7185 18.9585 12.5825 19.1339C12.4466 19.3094 12.3728 19.525 12.3729 19.747V21C12.3729 21.2652 12.2676 21.5196 12.08 21.7071C11.8925 21.8946 11.6382 22 11.3729 22C11.1077 22 10.8534 21.8946 10.6658 21.7071C10.4783 21.5196 10.3729 21.2652 10.3729 21V19.748C10.373 19.526 10.2993 19.3104 10.1633 19.1349C10.0274 18.9595 9.83691 18.8343 9.62194 18.779C8.39029 18.4597 7.26927 17.81 6.37994 16.9C6.22446 16.7415 6.02068 16.6393 5.8007 16.6094C5.58071 16.5796 5.35705 16.6237 5.16494 16.735L4.08094 17.362C3.96717 17.4287 3.84133 17.4722 3.71066 17.4901C3.58 17.508 3.44709 17.4998 3.31959 17.4661C3.19209 17.4324 3.07252 17.3738 2.96776 17.2937C2.863 17.2136 2.77512 17.1135 2.70918 16.9993C2.64323 16.8851 2.60054 16.759 2.58354 16.6282C2.56654 16.4974 2.57558 16.3646 2.61013 16.2373C2.64468 16.11 2.70407 15.9909 2.78487 15.8866C2.86567 15.7824 2.96629 15.6952 3.08094 15.63L4.16494 15C4.35689 14.8893 4.50661 14.7179 4.5906 14.5128C4.67458 14.3077 4.68807 14.0806 4.62894 13.867C4.2903 12.6399 4.2903 11.3441 4.62894 10.117C4.68603 9.90445 4.67141 9.67899 4.58734 9.47559C4.50327 9.2722 4.35444 9.10221 4.16394 8.992L3.07994 8.366C2.85013 8.23339 2.68241 8.01492 2.61368 7.75865C2.54495 7.50239 2.58083 7.22931 2.71344 6.9995C2.84605 6.76969 3.06452 6.60197 3.32078 6.53324C3.57705 6.46451 3.85013 6.50039 4.07994 6.633L5.16594 7.261C5.35752 7.37251 5.58072 7.41721 5.80047 7.38807C6.02021 7.35893 6.22405 7.25759 6.37994 7.1C7.27003 6.19134 8.39137 5.54302 9.62294 5.225C9.83857 5.16956 10.0295 5.04375 10.1656 4.8675C10.3016 4.69125 10.3749 4.47464 10.3739 4.252V3C10.3739 2.73478 10.4793 2.48043 10.6668 2.29289C10.8544 2.10536 11.1087 2 11.3739 2C11.6392 2 11.8935 2.10536 12.081 2.29289C12.2686 2.48043 12.3739 2.73478 12.3739 3V4.252C12.3738 4.47396 12.4476 4.68964 12.5835 4.86508C12.7195 5.04052 12.91 5.16573 13.1249 5.221C14.357 5.54015 15.4783 6.18988 16.3679 7.1C16.5234 7.25847 16.7272 7.36069 16.9472 7.39057C17.1672 7.42044 17.3908 7.37626 17.5829 7.265L18.6669 6.638C18.7807 6.5713 18.9065 6.52777 19.0372 6.5099C19.1679 6.49204 19.3008 6.50019 19.4283 6.5339C19.5558 6.56761 19.6754 6.6262 19.7801 6.70631C19.8849 6.78642 19.9728 6.88646 20.0387 7.00067C20.1046 7.11488 20.1473 7.24101 20.1643 7.37179C20.1813 7.50257 20.1723 7.63542 20.1377 7.76269C20.1032 7.88997 20.0438 8.00915 19.963 8.11337C19.8822 8.2176 19.7816 8.30482 19.6669 8.37L18.5829 9C18.392 9.11071 18.243 9.28148 18.1593 9.48569C18.0755 9.68991 18.0617 9.9161 18.1199 10.129V10.124Z"
							fill="#1E406A"
						/>
					</svg>
				)
			case 'mama-hands':
				return (
					<svg
						className={className || defaultClassname}
						width="25"
						height="19"
						viewBox="0 0 25 19"
						fill="#F4908B"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M20.4277 3.17539C20.1766 2.92429 19.918 2.70941 19.6537 2.52763C16.2534 0.189513 11.8936 3.32411 10.123 5.23636C12.642 7.64221 17.8142 13.1078 16.7151 14.6615C16.5544 14.8885 16.1726 15.3947 16.0281 15.5775M11.268 3.86241C9.28341 1.87781 4.85622 0.198517 2.33728 3.40442C-0.751985 7.33618 3.02425 11.211 3.94025 12.3351C5.61953 14.396 9.15473 17.6019 11.726 17.6019C14.2449 17.6019 18.6721 13.5564 20.1987 11.6482C20.5242 11.2413 20.7044 11.0409 20.9571 10.7102M13.7382 17.0205C13.9337 16.9867 14.685 16.4934 16.0281 15.5775M11.726 10.5032L16.0281 15.5775"
							stroke="white"
							strokeWidth="1.5"
						/>
						<path
							d="M10.0741 12.1428L14.425 16.7226M8.47119 13.2877L12.3641 17.4096M12.3641 7.56292L13.967 6.18896"
							stroke="white"
							strokeWidth="1.5"
						/>
						<path
							d="M24.6444 7.08259C24.7687 6.95838 24.836 6.78961 24.836 6.61752C24.836 6.44695 24.7729 6.27768 24.6476 6.15245C24.5234 6.02824 24.3546 5.96097 24.1825 5.96097H22.6126V4.38813C22.6126 4.15173 22.4851 3.93431 22.2825 3.818C22.0807 3.70216 21.8326 3.698 21.6258 3.81829C21.4205 3.93774 21.2962 4.15172 21.2962 4.38813V5.95779H19.7232C19.4867 5.95779 19.2693 6.08527 19.153 6.28787C19.0371 6.48967 19.033 6.73774 19.1533 6.9445C19.2727 7.14982 19.4867 7.27407 19.7232 7.27407H21.293V8.84373C21.293 9.08014 21.4205 9.29756 21.6232 9.41387C21.825 9.52971 22.0731 9.53387 22.2798 9.41358C22.4852 9.29413 22.6095 9.08014 22.6095 8.84373V7.27407H24.1793C24.3549 7.27407 24.5204 7.2066 24.6444 7.08259Z"
							fill="white"
							stroke="white"
							strokeWidth="0.2"
						/>
					</svg>
				)
			case 'mama-chat':
				return (
					<svg
						className={className || defaultClassname}
						width="20"
						height="18"
						viewBox="0 0 20 18"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M18.329 12.4441C16.986 15.1311 14.2405 16.829 11.2366 16.8302C10.4651 16.8322 9.01233 16.2824 8.03456 15.8713C7.38438 15.598 6.66328 15.5238 5.97904 15.6949L1.43799 16.8302L4.14428 12.4441C3.58896 11.3447 3.30118 10.1296 3.30439 8.89794C3.30556 5.89405 5.00345 3.14852 7.69045 1.80561C8.78987 1.25029 10.0049 0.962513 11.2366 0.965725H11.7032C15.7307 1.18792 18.9466 4.40382 19.1688 8.43134V8.89794C19.172 10.1296 18.8843 11.3447 18.329 12.4441Z"
							fill="#F4908B"
							stroke="white"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				)
			case 'mama-call':
				return (
					<svg
						className={className || defaultClassname}
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path d="M12.9546 7.90595L19.0007 1.85986" stroke="#F4908B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						<path d="M19.0007 7.04222V1.85986H13.8184" stroke="#F4908B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M18.1369 15.6102V18.2013C18.1389 18.6877 17.9357 19.1524 17.5773 19.4813C17.2188 19.8101 16.7384 19.9726 16.254 19.9288C13.5961 19.64 11.0431 18.7318 8.8 17.2771C6.71309 15.951 4.94375 14.1817 3.61764 12.0948C2.15793 9.8415 1.24951 7.27605 0.966001 4.60628C0.92236 4.12334 1.0837 3.6443 1.41062 3.28617C1.73753 2.92805 2.19992 2.72381 2.68482 2.72335H5.276C6.14306 2.71482 6.8821 3.35039 7.00345 4.20896C7.11282 5.0382 7.31564 5.8524 7.60806 6.63603C7.84536 7.26731 7.69358 7.97896 7.21938 8.4585L6.12245 9.55543C7.35201 11.7178 9.14243 13.5082 11.3048 14.7378L12.4017 13.6409C12.8813 13.1667 13.5929 13.0149 14.2242 13.2522C15.0078 13.5446 15.822 13.7474 16.6513 13.8568C17.5198 13.9793 18.1586 14.7333 18.1369 15.6102Z"
							fill="#F4908B"
						/>
					</svg>
				)
			case 'forward-arrow':
				return (
					<svg
						className={defaultClassname}
						viewBox="64 64 896 896"
						focusable="false"
						data-icon="right"
						width="1em"
						height="1em"
						fill="currentColor"
						aria-hidden="true">
						<path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z"></path>
					</svg>
				)
			case 'back-arrow':
				return (
					<svg
						className={defaultClassname}
						viewBox="64 64 896 896"
						focusable="false"
						data-icon="left"
						width="1em"
						height="1em"
						fill="currentColor"
						aria-hidden="true">
						<path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path>
					</svg>
				)
			default:
				return <div>{`(Icon: ${type})`}</div>
		}
	}

	return render(icon)
}

export default Icon
